import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b918949"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-h5 ringbearer" }, "Estadísticas", -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-h5 ringbearer" }, "Partidas de torneo", -1))
const _hoisted_6 = { key: 1 }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "No tienes partidas en torneos", -1))
const _hoisted_8 = [
  _hoisted_7
]

import LoadingGandalf from "@/components/Commons/LoadingGandalf.vue";
import SparklineElo from "@/components/Elo/SparklineElo.vue";
import CardPartidaTorneo from "@/components/PartidasTorneo/CardPartidaTorneo.vue";
import CardInscripcionesUsuarioTorneo from "@/components/PartidasTorneo/CardInscripcionesUsuarioTorneo.vue";
import CardTitleMisTorneos from "@/components/PartidasTorneo/CardTitleMisTorneos.vue";
import { useAuth } from "@/composables/useAuth";
import { FaccionDTO } from "@/interfaces/Faccion";
import { ViewPartidaTorneoDTO } from "@/interfaces/Partidas";
import { UsuarioDataDTO } from "@/interfaces/Usuario";
import { getFaccionByIdUser } from "@/services/FaccionesService";
import { getTournamentMatches } from "@/services/PartidaTorneoService";
import { ref, onMounted, computed } from "vue";
import { useRouter } from "vue-router";
import CardEstadisticas from "@/components/Perfil/CardEstadisticas.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'MisTorneosView',
  setup(__props) {

const isLoading = ref(true);
const { getidUsuario, getUser } = useAuth();
const router = useRouter();
const idUsuarioLogger = ref<number>(parseInt(getidUsuario.value));
const emailOwner = ref<string | null>(getUser.value);
const matches = ref<ViewPartidaTorneoDTO[]>([]);
const isLoadingMatches = ref<boolean>(false);
const faccionDTO = ref<FaccionDTO>({
  idFaccion: 0,
  nombreFaccion: "",
});
const usuarioData = ref<UsuarioDataDTO>({
  idUsuario: 0,
  nick: "",
  email: "",
  faccion: faccionDTO.value,
  partidasValidadas: [],
  partidasPendientes: [],
  elos: [],
  InscripcionesIndividualTorneo: [],
  InscripcionesEquipoTorneo: [],
  clasificacionElo: 0,
  puntuacionElo: 0,
  numeroPartidasJugadas: 0,
  partidasGanadas: 0,
  partidasEmpatadas: 0,
  partidasPerdidas: 0,
  proteccionDatos: null,
  PartidasTorneo: [],
  ClasificacionTorneos: [],
  rankingElo: 0,
});

//Variables para filtrar partidas segun el click en la barra de estadisticas
const filtroActivo = ref<"win" | "loss" | "draw" | null>(null);

const partidasFiltradas = computed(() => {
  if (!filtroActivo.value) return matches.value;

  return matches.value.filter((partida) => {
    const esVictoria = partida.ganadorPartidaTorneo === idUsuarioLogger.value;
    const esEmpate = partida.ganadorPartidaTorneo === null;
    const esDerrota =
      partida.ganadorPartidaTorneo &&
      partida.ganadorPartidaTorneo !== idUsuarioLogger.value;

    return (
      (filtroActivo.value === "win" && esVictoria) ||
      (filtroActivo.value === "draw" && esEmpate) ||
      (filtroActivo.value === "loss" && esDerrota)
    );
  });
});

const initializeComponent = async () => {
  if (idUsuarioLogger.value && emailOwner.value) {
    isLoading.value = true;
    isLoadingMatches.value = true;
    try {
      const response = await getTournamentMatches(idUsuarioLogger.value);
      matches.value = response.data;

      loadComunidad(idUsuarioLogger.value);
      usuarioData.value.email = emailOwner.value;

      loadResume(matches.value);

      loadRankingElo(idUsuarioLogger.value);
    } catch (error) {
      console.error(error);
      router.push({ name: "error" });
    } finally {
      isLoading.value = false;
      isLoadingMatches.value = false;
    }
  }
};

const loadResume = async (matches: ViewPartidaTorneoDTO[]) => {
  usuarioData.value.numeroPartidasJugadas = matches.length;

  let contadorGanadas = 0;
  let contadorEmpatadas = 0;
  let contadorPerdidas = 0;

  matches.forEach((element) => {
    if (element.ganadorPartidaTorneo == idUsuarioLogger.value)
      contadorGanadas++;
    else if (
      element.ganadorPartidaTorneo != idUsuarioLogger.value &&
      element.ganadorPartidaTorneo != null
    )
      contadorPerdidas++;
    else contadorEmpatadas++;
  });

  usuarioData.value.partidasGanadas = contadorGanadas;
  usuarioData.value.partidasEmpatadas = contadorEmpatadas;
  usuarioData.value.partidasPerdidas = contadorPerdidas;
};

onMounted(initializeComponent);

const loadComunidad = async (idUser: number) => {
  try {
    const response = await getFaccionByIdUser(idUser);
    usuarioData.value.faccion.nombreFaccion = response.data;
  } catch (error) {
    console.error("Error al obtener las comunidades: ", error);
  }
};

const loadRankingElo = async (idUser: number) => {
  // TODO MOSTRAR RANKING INDIVIDUAL ELO
  idUser;
  // try {
  //   console.log(idUser);
  //   const response = await getUsuarioData(idUser);
  //   //TODO Arreglo getRankingEloByIdUser
  //   //const response = await getRankingEloByIdUser(idUser);
  //   console.log(response.data);
  //   usuarioData.value.rankingElo = response.data.clasificacionElo;
  // } catch (error) {
  //   console.error("Error al obtener el ranking del jugador: ", error);
  // }
};

function filtrarPartidas(tipo: "win" | "loss" | "draw" | null) {
  filtroActivo.value = tipo;
}

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "text-center" }, {
    default: _withCtx(() => [
      (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(LoadingGandalf)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(CardTitleMisTorneos),
            _createVNode(_component_v_spacer, { class: "my-4" }),
            _createVNode(_component_v_row, { justify: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  md: "12"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { dense: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          md: "12",
                          class: "text-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(CardInscripcionesUsuarioTorneo, { usuario: usuarioData.value }, null, 8, ["usuario"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { dense: "" }),
                    _createVNode(_component_v_row, { dense: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6",
                          class: "text-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(SparklineElo, { idUsuario: idUsuarioLogger.value }, null, 8, ["idUsuario"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          sm: "6",
                          class: "text-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card, { class: "section-card stats-section pt-0 mt-0 mb-2" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _hoisted_3
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_divider),
                                _createVNode(_component_v_col, {
                                  cols: "12",
                                  md: "12",
                                  class: "text-center"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(CardEstadisticas, {
                                      usuario: usuarioData.value,
                                      onFiltroCambiar: filtrarPartidas
                                    }, null, 8, ["usuario"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (!isLoadingMatches.value && matches.value.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_v_card, { class: "section-card stats-section pt-0 mt-0" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, { cols: "12" }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_divider),
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partidasFiltradas.value, (match) => {
                            return (_openBlock(), _createBlock(_component_v_col, {
                              cols: "12",
                              sm: "6",
                              md: "6",
                              lg: "4",
                              xl: "4",
                              class: "pb-0",
                              key: match.idPartidaTorneo
                            }, {
                              default: _withCtx(() => [
                                _createVNode(CardPartidaTorneo, {
                                  idUsuario: idUsuarioLogger.value,
                                  match: match,
                                  class: "mb-4"
                                }, null, 8, ["idUsuario", "match"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8)),
            _createVNode(_component_v_divider, { class: "my-3" })
          ]))
    ]),
    _: 1
  }))
}
}

})